export default __webpack_public_path__ + "static/media/bg04.5226c551.jpg";